const resources = {};

export function loadResource(res) {
  if ( resources[res] )
    return resources[res];
  
  resources[res] = new Promise(resolve => {
    let script = createScript(res);
    script.onload = () => resolve(script);
  })

  return resources[res];
}

function createScript(src) {
  let script = document.createElement('script');
  script.src = src;
  document.body.appendChild(script);
  return script;
}


// WEBPACK FOOTER //
// ./scripts/components/optimisations/async-resource-manager.js